import styled from 'styled-components';

import { ThemeMode } from '@/helpers/enums';
import { device, typography } from '@/styles/helpers';
import { ScFormGroup } from '../../form/groups/styled';

interface FieldProps {
  mode?: ThemeMode;
}

export const ScFieldExpiryDateRow = styled.div<{ $list?: boolean }>`
  display: grid;
  grid-template-columns: ${({ $list }) =>
    $list ? 'repeat(1, 1fr)' : 'repeat(2, 1fr)'};
  grid-column-gap: 16px;
  grid-row-gap: 16px;
`;

export const ScFieldBanner = styled.div<FieldProps>`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;

  ${typography.caption1regular}

  & > svg {
    width: 20px;
    height: 20px;
    object-fit: contain;
    flex-shrink: 0;
    path {
      fill: ${({ theme, mode }) =>
        mode === ThemeMode.Dark ? theme.whiteColor : theme.blackColor};
    }
  }

  .payments-js-lib {
    &__wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &__img-wrapper {
      display: none;
    }

    &__description {
      font-size: 12px;
      line-height: 18px;
    }
  }
`;

export const ScFieldBannerOld = styled.div`
  .payments-js-lib {
    &__wrapper {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      margin: 24px 0;
    }

    &__description {
      padding-left: 16px;
      font-size: 14px;
      @media (${device.mobile}) {
        font-size: 12px;
      }
    }
  }
`;

export const ScCryptoBlock = styled.div<FieldProps>`
  &,
  .main-content,
  .code-details,
  .info {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
  }
  .info,
  .code-details {
    gap: 12px;
  }

  .main-content {
    ${ScFormGroup} {
      width: 100%;
      margin-bottom: 0;
    }

    .code-details {
      gap: 12px;
    }

    .subtitle {
      font-size: 16px;
      font-weight: 700;
      line-height: 24px;
      letter-spacing: 0.16px;
    }
  }

  .info {
    p {
      display: flex;
      align-items: center;
      gap: 8px;

      svg {
        width: 20px;
        height: 20px;
        object-fit: contain;
        flex-shrink: 0;

        path {
          fill: ${({ theme, mode }) =>
            mode === ThemeMode.Dark ? theme.whiteColor : theme.blackColor};
        }
      }

      b,
      span {
        font-size: 12px;
        line-height: 18px;
      }
    }
  }
`;
